export class KeypressValidator {
  constructor() {
  }

  public static checkOnlyNumber(event): boolean {
    const evt = event || window.event;
    let charCode = (evt.which) ? evt.which : evt.keyCode;

    return ((charCode <= 31) || (charCode >= 48 && charCode <= 57));
  }
}
